module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "elevation-0"
  }, [_c('v-slide-group', {
    attrs: {
      "active-class": "success",
      "show-arrows": ""
    },
    model: {
      value: (_vm.model),
      callback: function($$v) {
        _vm.model = $$v
      },
      expression: "model"
    }
  }, _vm._l((_vm.involucrados), function(i, index) {
    return _c('v-slide-item', {
      key: index,
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(ref) {
          var active = ref.active;
          var toggle = ref.toggle;

          return [_c('v-card', {
            staticClass: "mr-2",
            attrs: {
              "width": "85"
            },
            on: {
              "click": function () {}
            }
          }, [_c('v-img', {
            staticClass: "white--text align-end",
            attrs: {
              "height": _vm.isMovil ? 100 : 110,
              "src": i.foto ? i.foto : '/static/nobody.jpg',
              "gradient": "to bottom, rgba(0,0,0,.1),#161f2b85"
            }
          }, [_c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;
                var attrs = ref.attrs;

                return [(i.isCreador) ? _c('v-icon', _vm._g(_vm._b({
                  staticClass: "position"
                }, 'v-icon', attrs, false), on), [_vm._v("info")]) : _vm._e()]
              }
            }], null, true)
          }, [_c('small', [_vm._v("Creador del ticket")])]), _c('div', {
            staticClass: "d-flex fd-column pa-3"
          }, [_c('span', {
            class: _vm.isMovil ? 'font-size-11' : 'font-size-12'
          }, [_vm._v(_vm._s(i.nombre))]), (!_vm.isMovil) ? _c('span', {
            staticClass: "font-size-11 text-muted"
          }, [_vm._v(_vm._s(i.cargo))]) : _vm._e()])], 1)], 1)]
        }
      }], null, true)
    })
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2133cdb0","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/c_usuarios_involucrados_ticket.vue
// module id = 483
// module chunks = 1